import * as React from 'react';

import type {Configuration} from './group-configuration-table';

import styles from './configurations-column.module.css';

type Props = {
    header: string;
    configurations: Configuration[];
};

export function ConfigurationsColumn(props: Props) {
    return (
        <div className={styles['configurations-column']}>
            <div className={styles['configurations-column-cell']}>
                <strong>{props.header}</strong>
            </div>
            {props.configurations.map((configuration: Configuration) => (
                <div key={configuration.id} className={styles['configurations-column-cell']}>
                    {configuration.label}
                </div>
            ))}
        </div>
    );
}
